import isTouchDevice from './is-touch';
import { calendarFormat } from 'moment';

export class mainNavigation {
    fullSizeClass: string;
    shrinkClass: string;
    hideClass: string;
    visibleClass: string;
    isCollapsed: boolean;
    headerElement: HTMLElement;
    headerHeight: number;
    lastPos: number;
    curPos: number;
    delta: number;
    lastDelta: number;
    nav: HTMLElement;
    navContainer: HTMLElement;
    setForTouchscreen: Function;
    activeLink: HTMLElement;
    topNavs: Array<any>;

    constructor(navigation: HTMLElement) {
        this.fullSizeClass = 'expanded';
        this.shrinkClass = 'fixed';
        this.hideClass = 'collapsed';
        this.visibleClass = 'visible';
        this.isCollapsed = false;
        this.headerElement = document.querySelector('section') as HTMLElement; //first section on page
        this.nav = navigation;
        this.navContainer = document.querySelector('header') as HTMLElement;
        this.activeLink = null;
        this.topNavs = Array.prototype.slice.call(this.nav.querySelectorAll('.nav-main-list-item'));
        //setup callback function for if the device is a touch screen - 
        //first click just focuses to drop down the nav, 2nd click goes through
        this.setForTouchscreen = () => {
            this.topNavs.forEach((link, index) => {
                let anchor = link.querySelector('a');
                anchor.addEventListener('click', e => {
                    e.preventDefault();
                    if (anchor === this.activeLink) {
                        console.log("redirected");
                        window.location.href = anchor.href;
                    }
                    else {
                        this.activeLink = anchor;
                        link.classList.add('focused');
                    }
                })
            })
        }

        //deal with focus/keyboards     
        this.topNavs.forEach((topNav) => {
            let childTags = Array.prototype.slice.call(topNav.querySelectorAll('a'));
            childTags.forEach((childTag) => {
                childTag.addEventListener('focus', () => {
                    if (!topNav.classList.contains('focused')) {
                        topNav.classList.add('focused');
                    }
                    if (this.isCollapsed) {
                        this.navContainer.classList.remove(this.hideClass);
                        this.isCollapsed = false;
                        this.navContainer.classList.add(this.visibleClass);
                    }
                });
                childTag.addEventListener('blur', () => {
                    if (!topNav.contains(document.activeElement)) {
                        topNav.classList.remove('focused');
                    }
                });
            });
        });
        isTouchDevice(this.setForTouchscreen);

        this.initPos();
    }

    initPos() {
        this.headerHeight = Math.min((this.headerElement.getBoundingClientRect().bottom + window.pageYOffset), 500);
        this.curPos = window.pageYOffset;
        this.lastPos = this.curPos;
        this.setSubnavHeights();
        this.headerToggle();
    }

    headerToggle() {
        let originalHeaderHeight = this.navContainer.getBoundingClientRect().height;
        let documentScroll;
        let smallClass = "fixed-header";
        let largeClass = "normal-header";
        this.navContainer.classList.add(largeClass);
        window.addEventListener('scroll', () => {
            window.requestAnimationFrame(() => {
                documentScroll = window.scrollY || window.pageYOffset;

                if (documentScroll > originalHeaderHeight) {
                    this.navContainer.classList.add(smallClass);
                    this.navContainer.classList.remove(largeClass);
                }
                else {
                    this.navContainer.classList.remove(smallClass);
                    this.navContainer.classList.add(largeClass);
                }

                this.checkPos();
            });
        });

    }

    setSubnavHeights() {
        //smoother animated dropdowns
        this.topNavs.forEach(topNav => {
            let subNav = topNav.querySelector('.nav-main-list-child');
            subNav.classList.add('measuring');
            subNav.style.height = subNav.offsetHeight + 'px';
            subNav.classList.remove('measuring');
        })
    }

    checkPos() {
        this.curPos = window.pageYOffset;
        this.delta = this.curPos - this.lastPos; 
        this.lastPos = this.curPos;
        let navElement = document.querySelector('.nav') as HTMLElement;
        let navHeight = navElement.scrollHeight;
        let utilityNavHeight = document.getElementsByClassName("nav-utility-inner")[0].getBoundingClientRect().height;
        if (!this.isCollapsed) {
            if (this.delta > 0 && this.lastDelta > 0 && this.curPos >= navHeight) {
                this.navContainer.classList.add(this.hideClass);
                this.isCollapsed = true;
                this.navContainer.classList.remove(this.visibleClass);
            }
        }
        //if scrolling up
        else if ((this.delta < 0 && this.lastDelta < 0)) {
            let calendarPage = document.getElementsByClassName("calendar-nav").length > 0;
            
            if (!calendarPage || this.curPos < utilityNavHeight) {
                this.navContainer.classList.remove(this.hideClass);
                this.isCollapsed = false;
                setTimeout(() => {
                    this.navContainer.classList.add(this.visibleClass);
                }, 300);
            }
            
        }

        //if (this.curPos <= this.headerHeight) {
        //    if (!this.navContainer.classList.contains(this.fullSizeClass)) {
        //        this.navContainer.classList.remove(this.shrinkClass);
        //        this.navContainer.classList.add(this.fullSizeClass);
        //    }
        //}
        //else if (this.curPos > this.headerHeight) {
        //    if (!this.navContainer.classList.contains(this.shrinkClass)) {
        //        this.navContainer.classList.remove(this.fullSizeClass);
        //        this.navContainer.classList.add(this.shrinkClass);
        //    }
        //}

        this.lastDelta = this.delta;
    }

}